<div class="document-asset-list-container">
  <nav aria-label="Percorso di navigazione" class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/', ariaLabel: 'Home' }"
    ></p-breadcrumb>
  </nav>

  <header class="page-header" role="banner">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-file-word header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1>Template Documentali</h1>
          <p class="subtitle">
            Gestione dei template DOCX riusabili per generazione automatica di contratti e documenti
          </p>
        </div>
      </div>
      <div class="header-actions">
        <p-button
          label="Nuovo Template"
          icon="pi pi-plus"
          severity="primary"
          (onClick)="createNewTemplate()"
          aria-label="Carica nuovo template documentale"
        ></p-button>
      </div>
    </div>
  </header>

  <app-registry-table
    title="Lista Template"
    icon="pi-file-word"
    [columns]="columns"
    [data]="templatesData()"
    [loading]="isLoading()"
    [showClearFiltersButton]="true"
    [emptyStateMessage]="emptyMessage()"
    [ignoreStatusChecks]="true"
    (onEditClick)="onEditClick($event)"
    (onDownloadClick)="onDownloadClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
  >
    <label toolbar-extra for="template-show-inactive" class="registry-toggle">
      <span>Includi non attivi</span>
      <p-toggleswitch
        inputId="template-show-inactive"
        [ngModel]="showInactive()"
        (onChange)="onToggleShowInactive($event.checked)"
      ></p-toggleswitch>
    </label>
  </app-registry-table>

  <p-toast role="status" aria-live="polite" aria-atomic="true" />
  <p-confirmDialog role="alertdialog" aria-modal="true" />

  <app-document-asset-upload-wizard
    [(visible)]="wizardVisible"
    assetKind="template"
    [domainType]="currentDomainType()"
    [mode]="wizardMode()"
    [existingAsset]="editingAsset()"
    (registered)="onWizardRegistered($event)"
  ></app-document-asset-upload-wizard>
</div>
